export default __webpack_public_path__ + "static/media/img-logo.eb4dbde7.svg";